import { InputGroup, InputAdornment } from '@cian/ui-kit';

import styles from './RangeInput.css';
import { FC, useCallback, useEffect, useState } from 'react';
import { getValue, getMinForMaxField } from './utils';
import { MaskedInput } from '../MaskedInput';

export interface IRangeInputProps {
  joined?: boolean;
  postfix?: string;
  min?: number;
  max?: number;
  scale?: number;
  thousandsSeparator?: string;
  valueMin?: number | null;
  valueMax?: number | null;
  isForceUpdate?: boolean;
  allowMaxBelowMin?: boolean;
  disabled?: boolean;
  onChangeMin?(value: number | null): void;
  onChangeMax?(value: number | null): void;
}

export const RangeInput: FC<IRangeInputProps> = ({
  joined = true,
  postfix,
  min,
  max,
  scale = 0,
  thousandsSeparator = ' ',
  valueMin,
  valueMax,
  isForceUpdate,
  allowMaxBelowMin,
  disabled,
  onChangeMin,
  onChangeMax,
}) => {
  const [internalValueMin, setInternalValueMin] = useState<number | null>(
    typeof valueMin !== 'undefined' ? valueMin : null,
  );

  const handleChangeMin = useCallback(
    (valueRaw: string) => {
      const value = valueRaw ? Number(valueRaw) : null;
      if (value === valueMin) {
        return;
      }

      if (onChangeMin) {
        onChangeMin(value);
      }
    },
    [valueMin, onChangeMin],
  );

  const handleChangeMax = useCallback(
    (valueRaw: string) => {
      const value = valueRaw ? Number(valueRaw) : null;
      if (value === valueMax) {
        return;
      }

      if (onChangeMax) {
        onChangeMax(value);
      }
    },
    [valueMax, onChangeMax],
  );

  useEffect(() => {
    setInternalValueMin(typeof valueMin !== 'undefined' ? valueMin : null);
  }, [valueMin]);

  const rightAdornment = postfix && (
    <InputAdornment>
      <span className={styles['postfix']}>{postfix}</span>
    </InputAdornment>
  );

  return (
    <InputGroup spliced={joined}>
      <MaskedInput
        rightAdornment={rightAdornment}
        placeholder="от"
        mask={Number}
        min={min}
        max={max}
        scale={scale}
        thousandsSeparator={thousandsSeparator}
        mapToRadix={[',', '.', 'Б', 'Ю']}
        value={getValue(valueMin)}
        isForceUpdate={isForceUpdate}
        disabled={disabled}
        onComplete={handleChangeMin}
      />
      <MaskedInput
        rightAdornment={rightAdornment}
        placeholder="до"
        mask={Number}
        min={allowMaxBelowMin ? min : getMinForMaxField(internalValueMin, min)}
        max={max}
        scale={scale}
        thousandsSeparator={thousandsSeparator}
        mapToRadix={[',', '.', 'Б', 'Ю']}
        value={getValue(valueMax)}
        isForceUpdate={isForceUpdate}
        disabled={disabled}
        onComplete={handleChangeMax}
      />
    </InputGroup>
  );
};
